import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@tq/ui-components';

import { useIsMobile } from '@tq/ui-components/dist/hooks';
import { useRecoilState } from 'recoil';
import { searchViewTypeState } from 'store';
import { ConsultationViewTypes } from 'types';

export const ConsultationViewTypeMobile: React.FC = () => {
  const { t } = useTranslation('search_filter');
  const isMobile = useIsMobile();

  const [viewType, setViewType] = useRecoilState(searchViewTypeState);

  const toggleViewType = () =>
    setViewType((currentViewType) =>
      currentViewType === ConsultationViewTypes.Open
        ? ConsultationViewTypes.Archived
        : ConsultationViewTypes.Open
    );

  return (
    <>
      {isMobile && (
        <Link onClick={toggleViewType} fontSize='sm'>
          {viewType === ConsultationViewTypes.Open
            ? t('switch_to_archived', 'Switch to Archived')
            : t('switch_to_open', 'Switch to Open')}
        </Link>
      )}
    </>
  );
};
